import * as Sentry from '@sentry/react'
import { HttpClient } from '../api/client'
import { TokenManager } from '../auth/tokenManager'

/**
 * AI service for cleanup operations — fire-and-forget deletion of generated assets.
 */
export class AICleanupService {
  /** Delete images from storage by their public URLs. Fire-and-forget. */
  static async deleteImages(urls: string[]): Promise<void> {
    if (urls.length === 0) return

    try {
      const headers = await TokenManager.getAuthHeaders()
      if (!headers.Authorization) return

      await HttpClient.post('/ai/delete-images', { urls }, headers)
    } catch (error) {
      Sentry.captureException(error, {
        tags: { feature: 'service', action: 'delete_images' },
      })
      // Best-effort cleanup — don't block the UI
    }
  }
}
